import React from "react"
import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import FieldStoryPoints_Popover from "../../../../../generic/story-points/components/popover/popover"
import {EntityType} from "../../../../../../gd/const/item"
import {isBulkSelection} from "../../../../../../gd/right-click-menu"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type";

// const debug = "FieldItemModelStoryPointsCalculated_TableCell"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldItemModelStoryPointsCalculated_TableCell extends React.Component<FieldTableCellProps, State> {


    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get isEditable():boolean {
        switch (this.props.listItem.type) {

            case EntityType.TASK:
                return !this.props.manager.isReadOnly && this.props.listItem.task.acl.canChangeStoryPoints

            default:
                return false
        }
    }

    onMouseEnter = () => {

        if (!this.isEditable) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
// return
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange = (value:number|null, hidePopover:boolean=true) => {

        this.props.listItem.task.storyPoints = value
        this.props.listItem.task.save() // no await !

        // need it because of calculated values
        this.props.manager.updateChildrenItems();

        hidePopover && this.hidePopover()

        FieldProto_updateView(this.props.manager, this.props.field)
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null, false)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.isEditable) return

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    get style() {

        // this is common part for table cell
        // end common part

        const width = this.props.column.width

        const style : style = _.clone(this.props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    renderHovered() {

        const classes = Classes("cell-flex ui5-txt-less-important-small", {
            'is-hovered'        : this.state.isHovered
        })

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]

        const showChildren  = this.props.listItem.view.isCollapsed && !!calculatedValues?.children?.value && calculatedValues.children.value > 0
        const showOwn       = calculatedValues?.own > 0
        const showPlus      = showChildren && showOwn

        return (
            <React.Fragment>
                <div className={classes} style={this.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                    <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>

                        <div className="flex-row-left-center truncate">

                            {showOwn &&
                                <div className="ui5-txt-less-important-small">{calculatedValues?.own}</div>
                            }

                            {showPlus &&
                                <div className="ui5-txt-less-important-small m-r-5 m-l-5">+</div>
                            }

                            {showChildren &&
                                <>
                                    <div className="ui5-ico-12 i5-folder-tree m-r-5 m-t-1"/>
                                    <div className="ui5-txt-less-important-small">{calculatedValues.children.value}</div>
                                </>
                            }

                            {this.state.showPopover &&
                                <FieldStoryPoints_Popover
                                    field       = {this.props.field}
                                    parent      = {this}
                                    value       = {calculatedValues?.own}
                                    onChange    = {this.onValueChange}
                                />
                            }

                        </div>


                        <div className="buttons">
                            {showOwn &&
                                <div className="btn-reset" onClick={this.onDeleteClick}/>}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                </div>
            </React.Fragment>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small", {
            // 'is-hovered'        : this.state.isHovered
        })

        let notHoveredContent   = null
        let aggregateIcon

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]

        if (this.props.listItem.view.isCollapsed &&
            !!calculatedValues?.total &&
            calculatedValues.total.value != calculatedValues.own) {
            notHoveredContent = calculatedValues.total.value
            aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", this.props.column.aggregator?.icon)}/>
        } else if (calculatedValues?.own) {
            notHoveredContent = calculatedValues.own
        } else {
            // display nothing :)
        }

        return (
            <React.Fragment>
                <div className={classes} style={this.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {aggregateIcon}
                    {notHoveredContent}
                </div>
            </React.Fragment>
        )

    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)


        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()

    }

}



